import Logger from '../util/Logger';
import { popinApi, popinMultipartApi } from './api';
import RosterStatus from '../models/RosterStatus';
import { RosterStatusType } from '../models/RosterStatusType';
import { new400Error } from './ApiError';
import _ from 'lodash';
import Roster from '../models/Roster';

const resultToStatus = (result) => {
  return _.get(result, 'roster_status') || null;
};

const getRosterStatus = (rosterId) => {
  return Promise.resolve().then(() => {
    if (!rosterId) {
      Logger.info('reject getRosterStatus()');
      throw Error('Must pass rosterId');
    } else {
      return popinApi.get(`/rosters/${rosterId}/status`);
    }
  });
};

const uploadRoster = (csv) => {
  return Promise.resolve().then(() => {
    if (!csv) {
      Logger.info('reject uploadRoster()');
      throw Error('Must pass csv');
    } else {
      const formData = new FormData();
      const blobProps = { type: 'text/csv' };
      formData.append('csv', new Blob([csv], blobProps), 'roster.csv');
      return popinMultipartApi.post('/rosters', formData);
    }
  });
};

const listRoster = (rosterId) => {
  return Promise.resolve().then(() => {
    if (!rosterId) {
      Logger.info('reject listRoster()');
      throw Error('Must pass rosterId');
    } else {
      return popinApi.get(`/rosters/${rosterId}`)
        .then(roster => {
          // Construct a roster on the client side
          const userInfo = Roster.getUserInfo(roster);
          const tags = Roster.getTags(roster);
          return {
            id: rosterId,
            user_info: userInfo,
            tags: tags
          };
        });
    }
  });
};

const watchRosterStatus = (originalStatus) => {
  return new Promise((resolve, reject) => {
    const originalId = RosterStatus.getId(originalStatus);

    const watch = (id) => {
      getRosterStatus(id)
        .then(result => {
          const status = resultToStatus(result);
          const statusType = RosterStatus.getStatus(status);
          if (statusType === RosterStatusType.SUCCESS) {
            Logger.info('Roster status watcher: Success');
            clearInterval(intervalId);
            resolve(result);
          } else if (statusType === RosterStatusType.FAILED) {
            Logger.info('Roster status watcher: Failed');
            clearInterval(intervalId);
            reject(new400Error('Failed uploading roster', RosterStatus.getDescription(status)));
          }
        })
        .catch(error => {
          Logger.info('Roster status watcher: Error');
          clearInterval(intervalId);
          reject(error);
        });
    };

    // Every 5 seconds, query about the roster status
    const intervalId = setInterval(() => {
      watch(originalId);
    }, 1000);

    // Instant query as well.
    watch(originalId);
  });
};

export const rosterApi = {

  uploadRoster: (rosterCsv) => {
    return uploadRoster(rosterCsv)
      .then(result => watchRosterStatus(resultToStatus(result)))
      .then(result => listRoster(RosterStatus.getId(resultToStatus(result))));
  }
};
